import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';

import ogImg from '../../assets/img/og.jpg';
import '../../styles/pages/Gallery.css';

import Image from '../../components/shared/backgroundImage';

import Footer from '../../components/shared/Footer';
import NavBar from '../../components/shared/NavBar';
import Description from '../../components/shared/imageDescription';
import Explore from '../../components/shared/explore.js';
import Gallery from '../../components/gallery/gallery';

class gallery extends Component {
  constructor(props) {
    super(props);
    this.onTransitionEnd.bind(this);
  }
  state = {
    transitionEnded: false,
  };
  onTransitionEnd = () => {
    this.setState({ transitionEnded: true });
  };

  render() {
    const heroClasses = classnames('hero', 'gallery-page', {
      animate: this.state.transitionEnded,
    });
    if (!this.props.galleryPageQuery) {
      return <div className="u-hidden"> Waiting</div>;
    } else if (this.props.galleryPageQuery && this.props.galleryPageQuery.loading) {
      return <div className="u-hidden">Loading</div>;
    } else if (this.props.galleryPageQuery && this.props.galleryPageQuery.error) {
      return <div className="u-hidden">Error </div>;
    }

    this.data = this.props.galleryPageQuery;
    if (!this.data) {
      window.location.href = '/404';
      return null;
    }

    // Pass the single gallery page object (galleryPages[0]) to the component
    const galleryPage = this.data.galleryPages && this.data.galleryPages[0] ? this.data.galleryPages[0] : null;

    return (
      <div key="home" className={heroClasses}>
        <Helmet>
          <meta property="og:image" content={ogImg} />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
          />
        </Helmet>
        <header id="site-header" className="container" role="banner">
          <a id="site-title" className="h1" href="/">
            <img src={this.data.globalSites[0].cubsLogo.url} alt="site-header" />
          </a>
          <Image introBackgrounds={galleryPage} />
          <NavBar NavBar={this.data.globalSites[0].mainNavigation} />
          <div className="header-content">
            <div className="row2 padding-bottom">
              <Description description={galleryPage} />
            </div>
          </div>
        </header>
        <main className="container">
          {galleryPage && galleryPage.pageDescription && (
            <section className="section">
              <div className="row">
                <div className="col sm-12 gallery-copy">
                  <ReactMarkdown className="markdown-body" remarkPlugins={[remarkBreaks]} rehypePlugins={[rehypeRaw]}>
                    {galleryPage.pageDescription}
                  </ReactMarkdown>
                </div>
              </div>
            </section>
          )}
          <Gallery key={galleryPage && galleryPage.route} gallery={galleryPage} />
          {galleryPage && galleryPage.additionalInformation && (
            <section className="section additionalInformation">
              <div className="row">
                <div className="col sm-12 gallery-copy">
                  <ReactMarkdown className="markdown-body" remarkPlugins={[remarkBreaks]} rehypePlugins={[rehypeRaw]}>
                    {galleryPage.additionalInformation}
                  </ReactMarkdown>
                </div>
              </div>
            </section>
          )}
          <Explore explore={this.data.exploreComponents[0]} />
        </main>
        <Footer footer={this.data.globalSites[0].mainNavigation} />
      </div>
    );
  }
}

export default withRouter(gallery);